module.exports = __webpack_public_path__ + "img/NZD.4f7349f6.svg";